const localization = {
    cannot_delete_default_language: '你已設置 {{languageTag}} 為你的預設語言，你無法刪除預設語言。',
    invalid_translation_structure: '無效的資料格式，請檢查你的輸入並重試。',
};
export default Object.freeze(localization);
